// TODO: jw: extract the outside click listener to a helper function

export default {
    initDropdown() {
        let triggers = document.querySelectorAll(".js-dropdown-trigger");

        triggers.forEach(trigger => {
            trigger.addEventListener("mouseup", event => {

                const parent = trigger.closest(".js-dropdown");

                parent.classList.toggle("is-open");

                if (trigger.getAttribute("aria-expanded") === "true") {

                    trigger.setAttribute("aria-expanded", "false");
                } else {
                    trigger.setAttribute("aria-expanded", "true");
                }

                const outsideClickListener = event => {
                    if (!parent.contains(event.target) && isVisible(parent)) {
                        parent.classList.toggle("is-open");
                        if (trigger.getAttribute("aria-expanded") === "true") {

                            trigger.setAttribute("aria-expanded", "false");
                        } else {
                            trigger.setAttribute("aria-expanded", "true");
                        }
                        removeClickListener()
                    }
                };

                const removeClickListener = () => {
                    document.removeEventListener('click', outsideClickListener)
                };

                document.addEventListener('click', outsideClickListener);

                event.preventDefault();
            });
        });

        const isVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )
    }

};


